const instances = document.querySelectorAll('.expandable-table');

if (instances) {
    instances.forEach(instance => {
        const toggle = instance.querySelector(".expandable-table__toggle");
        const table = instance.querySelector(".expandable-table__table");

        if (toggle && table) {
            toggle.addEventListener('click', () => {
                if (instance.getAttribute("aria-expanded") === "false") {
                    instance.setAttribute("aria-expanded", "true");
                    toggle.querySelector("i").classList.remove("icon-bold-angleDown");
                    toggle.querySelector("i").classList.add("icon-bold-angleUp");
                } else {
                    instance.setAttribute("aria-expanded", "false");
                    toggle.querySelector("i").classList.remove("icon-bold-angleUp");
                    toggle.querySelector("i").classList.add("icon-bold-angleDown");
                }
            });
        }
    });

}